import React from 'react';
import { GridType } from '../../../../Entities/GridType';
import ProjectCapacity from './ProjectCapacity';

export const AllocationView = ({ setUseLegacyAllocation }: { setUseLegacyAllocation: React.Dispatch<React.SetStateAction<boolean>> }) => (
    <ProjectCapacity gridType={GridType.Allocation} setUseLegacyAllocation={setUseLegacyAllocation} />
);
